import { render, staticRenderFns } from "./userPageSetup.vue?vue&type=template&id=0f9d578e&scoped=true&"
import script from "./userPageSetup.vue?vue&type=script&lang=js&"
export * from "./userPageSetup.vue?vue&type=script&lang=js&"
import style0 from "./userPageSetup.vue?vue&type=style&index=0&id=0f9d578e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f9d578e",
  null
  
)

export default component.exports